module.exports = __webpack_public_path__ + "static/media/alessia-hover.0b3018b3.png";